import React from 'react';
import { ListChecks, Percent, Clock, CheckCircle, Calendar, MapPin, User , BookOpen } from 'lucide-react';

// Recibimos las props: cliente, className y onClick
const CardProPlataforma = ({ cliente, className, onClick }) => {
  const stats = cliente.estadisticas;
  
  if (!stats) {
    return (
      <tr className={className} onClick={onClick}>
        {/* Renderiza las celdas de cliente e info académica como las tenías */}
        <td className="px-6 py-4">
            <div className="text-sm font-medium text-gray-900">{cliente.nombreCliente}</div>
            <div className="text-sm text-gray-500">{cliente.numero}</div>
        </td>
        <td className="px-6 py-4">
            <div className="text-sm text-gray-900">{cliente.universidad}</div>
            <div className="text-sm text-gray-500">{cliente.carrera}</div>
        </td>
        {/* Celda para las estadísticas */}
        <td className="px-6 py-4 text-sm text-gray-500">
          No hay estadísticas disponibles para este semestre.
        </td>
      </tr>
    );
  }

  const proximaEntregaMasCercana = stats.proximasEntregas && stats.proximasEntregas.length > 0
    ? stats.proximasEntregas[0]
    : null;

  return (
    <tr className={className} onClick={onClick}>
      <td className="px-6 py-4 ">
        <div className="flex items-center">
          <User className="h-5 w-5 text-blue-600 mr-3" />
          <div>
            <div className="text-sm font-medium text-gray-900">
              #{cliente.numero} - {cliente.nombreCliente}
            </div>
            <div className="text-sm text-gray-500">
              {cliente.nombrecompletoCliente}
            </div>
          </div>
        </div>
      </td>
      <td className="px-6 py-4 ">
        <div className="space-y-1">
          {cliente.carrera && (
            <div className="flex items-center text-sm text-gray-700">
              <BookOpen className="h-4 w-4 text-blue-500 mr-2" />
              {cliente.carrera}
            </div>
          )}
          {cliente.universidad && (
            <div className="flex items-center text-sm text-gray-700">
              <MapPin className="h-4 w-4 text-green-500 mr-2" />
              {cliente.universidad}
            </div>
          )}
          {cliente.procedencia && (
            <div className="flex items-center text-sm text-gray-700">
              <MapPin className="h-4 w-4 text-purple-500 mr-2" />
              {cliente.contextoCliente}
            </div>
          )}
          <div className="flex items-center text-sm text-gray-700">
              <MapPin className="h-4 w-4 text-purple-500 mr-2" />
              {cliente.estadoClienteEspecial}
          </div>
          <div className="flex items-center text-sm text-gray-700">
              <MapPin className="h-4 w-4 text-purple-500 mr-2" />
              Estado de trabajo {cliente.estadoTrabajoUnadCurso}
          </div>
        </div>
      </td>
      <td className="px-6 py-4 text-sm">
        <div className="grid grid-cols-2 gap-x-4 gap-y-2">
          
          <div className="flex items-center" title="Porcentaje de pago completado">
            <Percent className="w-4 h-4 mr-2 text-green-500" />
            <strong>{((stats.percentPagado || 0) * 100).toFixed(0)}% Pagado</strong>
          </div>

          <div className="flex items-center" title="Próxima entrega más cercana">
            <Calendar className="w-4 h-4 mr-2 text-red-500" />
            {proximaEntregaMasCercana ? (
              <span>Próx: {new Date(proximaEntregaMasCercana.fechaEntrega).toLocaleDateString('es-CO', { month: 'long', day: 'numeric' })}</span>
            ) : (
              <span className="text-gray-400">Sin entregas</span>
            )}
          </div>
          
          <div className="flex items-center" title="Servicios totales en el semestre">
            <ListChecks className="w-4 h-4 mr-2 text-gray-500" />
            <span>{stats.numeroDeServicios} Servicios</span>
          </div>
          
          <div className="flex items-center" title="Trabajos pendientes de entrega">
            <Clock className="w-4 h-4 mr-2 text-orange-500" />
            <span>{stats.numeroTrabajosPendientes} Pendientes</span>
          </div>

          <div className="flex items-center" title="Trabajos verificados por el administrador">
            <CheckCircle className="w-4 h-4 mr-2 text-blue-500" />
            <span>{stats.numeroTrabajosCheckeadosAdmin} Verificados</span>
          </div>

        </div>
      </td>
    </tr>
  );
};

export default CardProPlataforma;